import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const AnimalCareConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/animal-care",
    component: React.lazy(() => import("./animal-care")),
  },
];
